/**
 * Pictoirel Design Studio — Layout Template Definitions (Phase 11)
 *
 * All templates operate on the full 2-page spread.
 * Coordinates are in printable space: x: 0–800, y: 0–566
 * 12px margin from bleed trim is the recommended minimum.
 *
 * Schema:
 *   id       — unique slug
 *   name     — human-friendly label shown in picker
 *   category — groups templates in the sidebar
 *   slots[]  — each slot: { id, x, y, w, h, aspect?, fit }
 *              fit: 'fill' = cover (crop to fill), 'contain' = letterbox
 *
 * Usage:
 *   const tmpl = DS_TEMPLATES.find(t => t.id === 'four_grid');
 *   window.applyTemplate(tmpl.id);
 */
(function() {
  'use strict';

  var DS_TEMPLATES = [

    // ═══════════════════════════════════════════════════════════════
    //  1 Photo
    // ═══════════════════════════════════════════════════════════════
    {
      id: 'single_full_bleed',
      name: 'Full Spread',
      category: '1 Photo',
      slots: [
        { id: 's1', x: 0, y: 0, w: 800, h: 566, aspect: null, fit: 'fill' }
      ]
    },
    {
      id: 'single_left_full',
      name: 'Left Page',
      category: '1 Photo',
      slots: [
        { id: 's1', x: 12, y: 12, w: 376, h: 542, aspect: null, fit: 'fill' }
      ]
    },
    {
      id: 'single_right_full',
      name: 'Right Page',
      category: '1 Photo',
      slots: [
        { id: 's1', x: 412, y: 12, w: 376, h: 542, aspect: null, fit: 'fill' }
      ]
    },
    {
      id: 'single_centered',
      name: 'Centered',
      category: '1 Photo',
      slots: [
        { id: 's1', x: 160, y: 80, w: 480, h: 406, aspect: null, fit: 'fill' }
      ]
    },
    {
      id: 'single_left_portrait',
      name: 'Portrait Left',
      category: '1 Photo',
      slots: [
        { id: 's1', x: 80, y: 40, w: 240, h: 486, aspect: 0.49, fit: 'fill' }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    //  2 Photos
    // ═══════════════════════════════════════════════════════════════
    {
      id: 'two_split_equal',
      name: 'Two Pages',
      category: '2 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 376, h: 542, aspect: null, fit: 'fill' },
        { id: 's2', x: 412, y: 12, w: 376, h: 542, aspect: null, fit: 'fill' }
      ]
    },
    {
      id: 'two_stack_left',
      name: 'Stack Left',
      category: '2 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 376, h: 263, aspect: 1.43, fit: 'fill' },
        { id: 's2', x: 12, y: 287, w: 376, h: 263, aspect: 1.43, fit: 'fill' }
      ]
    },
    {
      id: 'two_large_small',
      name: 'Feature + Accent',
      category: '2 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 520, h: 542, aspect: 0.96, fit: 'fill' },
        { id: 's2', x: 548, y: 12, w: 240, h: 242, aspect: 0.99, fit: 'fill' }
      ]
    },
    {
      id: 'two_landscape_stack',
      name: 'Landscape Stack',
      category: '2 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 776, h: 263, aspect: 2.95, fit: 'fill' },
        { id: 's2', x: 12, y: 291, w: 776, h: 263, aspect: 2.95, fit: 'fill' }
      ]
    },
    {
      id: 'two_right_large_left_small',
      name: 'Right Feature',
      category: '2 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 240, h: 242, aspect: 0.99, fit: 'fill' },
        { id: 's2', x: 268, y: 12, w: 520, h: 542, aspect: 0.96, fit: 'fill' }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    //  3 Photos
    // ═══════════════════════════════════════════════════════════════
    {
      id: 'three_equal_row',
      name: 'Three Row',
      category: '3 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 247, h: 542, aspect: 0.46, fit: 'fill' },
        { id: 's2', x: 275, y: 12, w: 247, h: 542, aspect: 0.46, fit: 'fill' },
        { id: 's3', x: 541, y: 12, w: 247, h: 542, aspect: 0.46, fit: 'fill' }
      ]
    },
    {
      id: 'three_feature_left',
      name: 'Feature + Two Right',
      category: '3 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 480, h: 542, aspect: 0.89, fit: 'fill' },
        { id: 's2', x: 508, y: 12, w: 280, h: 263, aspect: 1.07, fit: 'fill' },
        { id: 's3', x: 508, y: 291, w: 280, h: 263, aspect: 1.07, fit: 'fill' }
      ]
    },
    {
      id: 'three_feature_right',
      name: 'Two Left + Feature',
      category: '3 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 280, h: 263, aspect: 1.07, fit: 'fill' },
        { id: 's2', x: 12, y: 291, w: 280, h: 263, aspect: 1.07, fit: 'fill' },
        { id: 's3', x: 308, y: 12, w: 480, h: 542, aspect: 0.89, fit: 'fill' }
      ]
    },
    {
      id: 'three_top_large',
      name: 'Top Feature + Two Below',
      category: '3 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 776, h: 340, aspect: 2.28, fit: 'fill' },
        { id: 's2', x: 12, y: 368, w: 378, h: 186, aspect: 2.03, fit: 'fill' },
        { id: 's3', x: 406, y: 368, w: 378, h: 186, aspect: 2.03, fit: 'fill' }
      ]
    },
    {
      id: 'three_bottom_large',
      name: 'Two Top + Bottom Feature',
      category: '3 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 378, h: 186, aspect: 2.03, fit: 'fill' },
        { id: 's2', x: 406, y: 12, w: 378, h: 186, aspect: 2.03, fit: 'fill' },
        { id: 's3', x: 12, y: 214, w: 776, h: 340, aspect: 2.28, fit: 'fill' }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    //  4 Photos
    // ═══════════════════════════════════════════════════════════════
    {
      id: 'four_grid',
      name: '4-Grid',
      category: '4 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 376, h: 263, aspect: 1.43, fit: 'fill' },
        { id: 's2', x: 412, y: 12, w: 376, h: 263, aspect: 1.43, fit: 'fill' },
        { id: 's3', x: 12, y: 291, w: 376, h: 263, aspect: 1.43, fit: 'fill' },
        { id: 's4', x: 412, y: 291, w: 376, h: 263, aspect: 1.43, fit: 'fill' }
      ]
    },
    {
      id: 'four_mosaic',
      name: 'Mosaic',
      category: '4 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 480, h: 542, aspect: 0.89, fit: 'fill' },
        { id: 's2', x: 508, y: 12, w: 280, h: 172, aspect: 1.63, fit: 'fill' },
        { id: 's3', x: 508, y: 200, w: 280, h: 172, aspect: 1.63, fit: 'fill' },
        { id: 's4', x: 508, y: 382, w: 280, h: 172, aspect: 1.63, fit: 'fill' }
      ]
    },
    {
      id: 'four_portrait_strip',
      name: 'Portrait Strip',
      category: '4 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 183, h: 542, aspect: 0.34, fit: 'fill' },
        { id: 's2', x: 211, y: 12, w: 183, h: 542, aspect: 0.34, fit: 'fill' },
        { id: 's3', x: 410, y: 12, w: 183, h: 542, aspect: 0.34, fit: 'fill' },
        { id: 's4', x: 605, y: 12, w: 183, h: 542, aspect: 0.34, fit: 'fill' }
      ]
    },
    {
      id: 'four_l_shape',
      name: 'L-Shape',
      category: '4 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 520, h: 340, aspect: 1.53, fit: 'fill' },
        { id: 's2', x: 548, y: 12, w: 240, h: 340, aspect: 0.71, fit: 'fill' },
        { id: 's3', x: 12, y: 368, w: 376, h: 186, aspect: 2.02, fit: 'fill' },
        { id: 's4', x: 406, y: 368, w: 382, h: 186, aspect: 2.05, fit: 'fill' }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    //  5 Photos
    // ═══════════════════════════════════════════════════════════════
    {
      id: 'five_collage',
      name: '5-Collage',
      category: '5 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 376, h: 340, aspect: 1.11, fit: 'fill' },
        { id: 's2', x: 412, y: 12, w: 376, h: 340, aspect: 1.11, fit: 'fill' },
        { id: 's3', x: 12, y: 368, w: 240, h: 186, aspect: 1.29, fit: 'fill' },
        { id: 's4', x: 268, y: 368, w: 240, h: 186, aspect: 1.29, fit: 'fill' },
        { id: 's5', x: 524, y: 368, w: 264, h: 186, aspect: 1.42, fit: 'fill' }
      ]
    },
    {
      id: 'five_mixed',
      name: '5-Mixed',
      category: '5 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 480, h: 340, aspect: 1.41, fit: 'fill' },
        { id: 's2', x: 508, y: 12, w: 280, h: 263, aspect: 1.07, fit: 'fill' },
        { id: 's3', x: 508, y: 291, w: 280, h: 263, aspect: 1.07, fit: 'fill' },
        { id: 's4', x: 12, y: 368, w: 240, h: 186, aspect: 1.29, fit: 'fill' },
        { id: 's5', x: 268, y: 368, w: 224, h: 186, aspect: 1.20, fit: 'fill' }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    //  6 Photos
    // ═══════════════════════════════════════════════════════════════
    {
      id: 'six_grid',
      name: '6-Grid',
      category: '6 Photos',
      slots: [
        { id: 's1', x: 12, y: 12, w: 247, h: 263, aspect: 0.94, fit: 'fill' },
        { id: 's2', x: 275, y: 12, w: 247, h: 263, aspect: 0.94, fit: 'fill' },
        { id: 's3', x: 541, y: 12, w: 247, h: 263, aspect: 0.94, fit: 'fill' },
        { id: 's4', x: 12, y: 291, w: 247, h: 263, aspect: 0.94, fit: 'fill' },
        { id: 's5', x: 275, y: 291, w: 247, h: 263, aspect: 0.94, fit: 'fill' },
        { id: 's6', x: 541, y: 291, w: 247, h: 263, aspect: 0.94, fit: 'fill' }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    //  Special
    // ═══════════════════════════════════════════════════════════════
    {
      id: 'blank',
      name: 'Blank',
      category: 'Special',
      slots: []
    },
    {
      id: 'text_only',
      name: 'Text Page',
      category: 'Special',
      slots: []
    }
  ];

  // ─── Template Thumbnail Renderer ──────────────────────────────────
  // Renders a 160×101px wireframe preview of template slots using
  // a Fabric.js StaticCanvas. Called lazily when the Layouts tab opens.

  function renderTemplateThumbnail(template, canvasEl) {
    if (typeof fabric === 'undefined') return;
    var sc = new fabric.StaticCanvas(canvasEl, {
      width: 160, height: 101, backgroundColor: '#fafafa'
    });
    var sx = 160 / 800;
    var sy = 101 / 566;

    template.slots.forEach(function(slot) {
      var rect = new fabric.Rect({
        left: slot.x * sx,
        top: slot.y * sy,
        width: slot.w * sx,
        height: slot.h * sy,
        fill: '#e8e8e8',
        stroke: '#c0c0c0',
        strokeWidth: 1,
        rx: 2, ry: 2,
        selectable: false,
        originX: 'left',
        originY: 'top'
      });
      sc.add(rect);
    });

    // Spine line (center divider)
    var spine = new fabric.Line([80, 0, 80, 101], {
      stroke: '#d0d0d0',
      strokeWidth: 1,
      strokeDashArray: [3, 3],
      selectable: false
    });
    sc.add(spine);
    sc.renderAll();
    sc.dispose();
  }

  // ─── Layout Panel Builder ─────────────────────────────────────────
  // Populates the #ds-layout-grid panel with category headers and
  // clickable thumbnail tiles. Idempotent — safe to call multiple times.

  window.buildLayoutPanel = function() {
    var grid = document.getElementById('ds-layout-grid');
    if (!grid || grid._built) return;
    grid._built = true;

    // Group by category
    var cats = {};
    DS_TEMPLATES.forEach(function(t) {
      if (!cats[t.category]) cats[t.category] = [];
      cats[t.category].push(t);
    });

    Object.keys(cats).forEach(function(cat) {
      // Category label
      var label = document.createElement('div');
      label.className = 'ds-layout-category-label';
      label.textContent = cat;
      grid.appendChild(label);

      // Template tiles
      cats[cat].forEach(function(tmpl) {
        var wrapper = document.createElement('div');
        wrapper.style.cssText = 'cursor:pointer;';

        var thumb = document.createElement('div');
        thumb.className = 'ds-layout-thumb' +
          (window._currentTemplateId === tmpl.id ? ' is-active' : '');
        thumb.setAttribute('data-template', tmpl.id);

        var canvasEl = document.createElement('canvas');
        thumb.appendChild(canvasEl);

        var nameEl = document.createElement('div');
        nameEl.className = 'ds-layout-name';
        nameEl.textContent = tmpl.name;

        wrapper.appendChild(thumb);
        wrapper.appendChild(nameEl);
        wrapper.onclick = function() {
          grid.querySelectorAll('.ds-layout-thumb').forEach(function(el) {
            el.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
          window.applyTemplate(tmpl.id);
        };
        grid.appendChild(wrapper);

        // Render thumbnail async to avoid layout thrash
        setTimeout(function() { renderTemplateThumbnail(tmpl, canvasEl); }, 0);
      });
    });
  };

  // ─── Apply Template Algorithm ─────────────────────────────────────
  // Rearranges existing image objects on the canvas into template slots.
  // Preserves text, shapes, stickers. Overflow photos are moved back
  // to the sidebar tray.

  window.applyTemplate = function(templateId) {
    if (!window.fabricCanvas) return;
    var template = DS_TEMPLATES.find(function(t) { return t.id === templateId; });
    if (!template) return;

    // 1. Collect existing image objects (exclude paper, text, shapes, stickers)
    var existing = window.fabricCanvas.getObjects()
      .filter(function(o) {
        return !o.isPaper && !o._isCropRect && !o.isText && !o.isShape
          && !o.isSticker && !o.isBackground && o.type === 'image';
      })
      .sort(function(a, b) {
        return (a._placedOrder || 0) - (b._placedOrder || 0);
      });

    // 2. Store image data for reuse
    var photos = existing.map(function(obj) {
      return {
        customUrl: obj.customUrl,
        customThumbSrc: obj.customThumbSrc,
        photoId: obj.photoId,
        rawPath: obj.rawPath,
        sourcePath: obj.sourcePath,
        printPath: obj.printPath,
        statusPath: obj.statusPath,
        cropX: obj.cropX || 0,
        cropY: obj.cropY || 0,
        originalWidth: obj.originalWidth || obj.width,
        originalHeight: obj.originalHeight || obj.height,
        filters: obj.filters || [],
        targetImgData: obj.targetImgData || null
      };
    });

    // 3. Remove existing images from canvas
    existing.forEach(function(o) { window.fabricCanvas.remove(o); });

    // 4. Place photos into template slots
    var slots = template.slots;
    var loadCount = 0;
    var totalToLoad = Math.min(slots.length, photos.length);

    if (totalToLoad === 0) {
      // No photos or blank template — just render
      window.fabricCanvas.renderAll();
      window._currentTemplateId = templateId;
      if (typeof saveHistory === 'function') saveHistory();
      return;
    }

    slots.forEach(function(slot, i) {
      if (i >= photos.length) return;
      var photo = photos[i];
      var canvasX = slot.x + slot.w / 2 + 100; // +100 for bleed offset
      var canvasY = slot.y + slot.h / 2 + 100;
      var src = photo.customThumbSrc || photo.customUrl;

      fabric.Image.fromURL(src, function(img) {
        if (!img) { loadCount++; return; }

        // Scale to FILL the slot (cover mode)
        var scX = slot.w / (photo.originalWidth || img.width);
        var scY = slot.h / (photo.originalHeight || img.height);
        var scale = Math.max(scX, scY);

        // Crop to centre of the image within the slot
        var cropW = slot.w / scale;
        var cropH = slot.h / scale;
        var origW = photo.originalWidth || img.width;
        var origH = photo.originalHeight || img.height;

        img.set({
          left: canvasX,
          top: canvasY,
          originX: 'center',
          originY: 'center',
          scaleX: scale,
          scaleY: scale,
          cropX: Math.max(0, (origW - cropW) / 2),
          cropY: Math.max(0, (origH - cropH) / 2),
          width: cropW,
          height: cropH,
          customUrl: photo.customUrl,
          customThumbSrc: photo.customThumbSrc,
          photoId: photo.photoId,
          rawPath: photo.rawPath,
          sourcePath: photo.sourcePath,
          printPath: photo.printPath,
          statusPath: photo.statusPath,
          crossOrigin: 'anonymous',
          originalWidth: origW,
          originalHeight: origH,
          slotId: slot.id,
          templateId: templateId,
          targetImgData: photo.targetImgData,
          _fitFillMode: 'fill',
          _placedOrder: i
        });

        // Restore filters if any
        if (photo.filters && photo.filters.length > 0) {
          img.filters = photo.filters;
          img.applyFilters();
        }

        window.fabricCanvas.add(img);
        loadCount++;

        // When ALL slot images have loaded → render + save
        if (loadCount >= totalToLoad) {
          window.fabricCanvas.renderAll();
          window._currentTemplateId = templateId;
          if (typeof saveHistory === 'function') saveHistory();
          if (typeof updateGalleryUI === 'function') updateGalleryUI();
        }
      }, { crossOrigin: 'anonymous' });
    });

    // 5. Handle overflow photos (more photos than slots)
    if (photos.length > slots.length) {
      var overflowCount = photos.length - slots.length;
      // Mark overflow photos as unused in the gallery tray
      var overflowPhotos = photos.slice(slots.length);
      overflowPhotos.forEach(function(p) {
        var thumbEl = document.querySelector('img[src="' + (p.customThumbSrc || '') + '"]');
        if (thumbEl) {
          var wrapper = thumbEl.closest('.gallery-item-wrapper');
          if (wrapper) wrapper.classList.remove('is-used');
        }
      });
      if (typeof showToast === 'function') {
        showToast(overflowCount + ' photo(s) moved back to your tray.', 4000, 'default');
      }
    }
  };

  // ─── Expose template array globally ───────────────────────────────
  window.DS_TEMPLATES = DS_TEMPLATES;

})();
